export default function toggleInArray(a: any[], v: any) {
  const i = a.indexOf(v)
  const a2 = a.slice()
  if (i === -1) a2.push(v)
  else a2.splice(i, 1)
  return a2
}
